// trace:FEAT-0002
import type { ApiClient } from "./client";
import type { AccountStatement, StatementQuery } from "./types/reporting";

const BASE = "/api/v1/reports";

/** Converts a typed query object to a URL search params string. */
function toSearchParams(query: StatementQuery): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value !== undefined) {
      params.set(key, value);
    }
  }
  return params.toString();
}

export function createReportingService(client: ApiClient) {
  return {
    getStatement: (query: StatementQuery) =>
      client.fetch<AccountStatement>(
        `${BASE}/statement?${toSearchParams(query)}`,
      ),
  };
}

export type ReportingService = ReturnType<typeof createReportingService>;
